import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { AutoAttendStatusBadge } from '@copilot/ui';
import { ACTIVE_STATES, BOT_STATES } from '../../constants/botMeetings';
import * as botMeetingApi from '../../services/botMeetingApi';
import { formatDateTime } from '../../utils/botMeetings';

const MAX_ITEMS = 3;
const SHOWN_STATES = [BOT_STATES.SCHEDULED, ...ACTIVE_STATES];

// Dashboard teaser. Renders nothing at all while loading, on any error
// (including the feature being disabled) and when there is nothing to
// show, so the dashboard never depends on bot-meeting availability.
function UpcomingAutoAttendCard() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;

    botMeetingApi
      .listBotMeetings('upcoming')
      .then((data) => {
        if (cancelled || !Array.isArray(data)) return;
        setItems(data.filter((m) => SHOWN_STATES.includes(m.bot_state)).slice(0, MAX_ITEMS));
      })
      .catch(() => {
        // Hidden on failure by design.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="auto-attend-dashboard-card" aria-label="Upcoming Auto Attend">
      <div className="auto-attend-dashboard-header">
        <h2>Upcoming Auto Attend</h2>
        <Link to="/app/auto-attend">View all</Link>
      </div>
      <ul>
        {items.map((meeting) => (
          <li key={meeting.meeting_id}>
            <div>
              <strong>{meeting.title}</strong>
              <span>{formatDateTime(meeting.scheduled_start_at)}</span>
            </div>
            <AutoAttendStatusBadge state={meeting.bot_state} />
          </li>
        ))}
      </ul>
    </section>
  );
}

export default UpcomingAutoAttendCard;
